import { ChevronLeft, ChevronRight } from 'lucide-react';
import { useState } from 'react';
import './ImageGallery.css';

function ImageGallery({ images }) {
  const list = Array.isArray(images) && images.length > 0 ? images : [];
  const [activeIndex, setActiveIndex] = useState(0);
  const displayList = list.length ? list : [];

  if (displayList.length === 0) return null;

  const move = (direction) => {
    setActiveIndex((prevIndex) => {
      const newIndex = prevIndex + direction;
      if (newIndex < 0) return displayList.length - 1;
      if (newIndex >= displayList.length) return 0;
      return newIndex;
    });
  };

  return (
    <div className="imageGallery">
      <div className="imageGalleryMain">
        {displayList.length > 1 && (
          <button
            type="button"
            className="galleryNav galleryPrev"
            onClick={() => move(-1)}
            aria-label="Previous image"
          >
            <ChevronLeft size={24} />
          </button>
        )}
        <img src={displayList[activeIndex]} alt="" />
        {displayList.length > 1 && (
          <button
            type="button"
            className="galleryNav galleryNext"
            onClick={() => move(1)}
            aria-label="Next image"
          >
            <ChevronRight size={24} />
          </button>
        )}
      </div>
      {displayList.length > 1 && (
        <div className="imageGalleryThumbs">
          {displayList.map((src, i) => (
            <button
              type="button"
              key={i}
              className={`imageGalleryThumb ${i === activeIndex ? 'active' : ''}`}
              onClick={() => setActiveIndex(i)}
            >
              <img src={src} alt="" />
            </button>
          ))}
        </div>
      )}
    </div>
  );
}

export default ImageGallery;
